import React from "react";
import { Col, Row, Form, Select, Button, Input, DatePicker } from "antd";
import moment from "moment";
import { ExportTypes } from "_helpers";

function Search({ onSearch, onClear }) {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    let searchParams = [];

    if (values.customReferenceNumber) {
      searchParams.push(
        `customReferenceNumber=${encodeURIComponent(
          values.customReferenceNumber
        )}`
      );
    }

    if (values.stockIssueType) {
      searchParams.push(
        `stockIssueType=${encodeURIComponent(values.stockIssueType)}`
      );
    }

    if (values.exportDateRange) {
      searchParams.push(
        `fromDate=${encodeURIComponent(
          moment(values.exportDateRange[0]).startOf("day").format("YYYY-MM-DD")
        )}&toDate=${moment(values.exportDateRange[1])
          .startOf("day")
          .format("YYYY-MM-DD")}`
      );
    }

    const queryValue =
      searchParams.length > 0 ? `?${searchParams.join("&")}` : "";

    onSearch(queryValue);
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      className="search-form"
    >
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item label="Cus.Dec.No#" name="customReferenceNumber">
            <Input placeholder="Enter Export cus.Dec.No" />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item name="stockIssueType" label="Export Type">
            <Select
              showSearch
              allowClear
              showArrow={false}
              optionFilterProp="children"
              placeholder="Export Type"
            >
              {ExportTypes.map((t, index) => (
                <Select.Option value={t.value} key={t.value}>
                  {t.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item label="Export Date" name="exportDateRange">
            <DatePicker.RangePicker
              ranges={{
                Today: [moment(), moment()],
                "This Month": [
                  moment().startOf("month"),
                  moment().endOf("month"),
                ],
              }}
            />
          </Form.Item>
        </Col>

        <Col span={6} style={{ textAlign: "right" }}>
          <div>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button
              style={{ margin: "0 8px" }}
              onClick={() => {
                form.resetFields();
                onClear();
              }}
            >
              Clear
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
}

export default Search;
